import axios from "axios";

// const baseUrl = process.env.VUE_APP_BASE_URL;

export const client = axios.create({
    // baseURL: baseUrl,
    timeout: 30 * 1000,
    // headers: {
    //     "User-Agent" : navigator.userAgent
    // }
});
